const monthEnding = (num) => {
  let result = "";
  if (((num - 1) % 10 === 0) && ((num-11) % 100 !==0)) result = "месяц";
  else if (
    ((num - 2) % 10 === 0 || (num - 3) % 10 === 0 || (num - 4) % 10 === 0) &&
    ((num - 11) % 100 !== 0 && (num - 12) % 100 !== 0 && (num - 13) % 100 !== 0 && (num - 14) % 100 !== 0)
  )
    result = "месяца";
  else result = "месяцев";
  
  return result;
}

export default monthEnding;